import { g as getPriceRange } from "../../../../chunks/utils2.js";
import { json } from "@sveltejs/kit";
const GET = () => {
  return json(getPriceRange());
};
export {
  GET
};
